import { useLocalization } from "@/data/Localization";
import { displayStoreWithStock } from "@/data/types/Store";
import { Box, Button, Stack, Typography } from "@mui/material";
import { FC, useContext, useState } from "react";
import { pickStoreBtnSx, pickStoreLinkSx, StoreDetailSX } from "../styles/storeDetailsDisplay";
import { StoreStockDetailsDisplay } from "./StoreStockDetailsDisplay";
import { StoreDetailsPopup } from "./StoreDetailsPopup";
import { ContentContext } from "@/data/context/content";
import { useClickAndCollect } from "@/data/Content/ClickAndCollect";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

type Props = {
    setSelectedStore:(store:displayStoreWithStock | undefined)=>void
}

export const StoreDetailsDisplay: FC<Props> = ({ setSelectedStore }) => {
    const ClickAndCollectNLS = useLocalization("ClickAndCollect");
    const [popupStoreAndFeature, setPopupStoreAndFeature] = useState<displayStoreWithStock>();

    const {
        displayStores,
    } = useContext(ContentContext) as ReturnType<typeof useClickAndCollect>;

    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
    
    return (
        <>
            {displayStores?.map(({store, feature, stock}, i) =>
                <Stack key={i} sx={{ ...StoreDetailSX, borderTop: i === 0 ? '1.5px solid black' : 'none' }}>
                    <Box width={'100%'}>
                        <Typography variant="h4" pb={0} onClick={()=>setPopupStoreAndFeature({store, feature, stock})} sx={{cursor:'pointer'}}>
                            {store.storeName}&nbsp;&nbsp;&#40;{parseFloat(store.distance).toFixed(2)}km&#41;
                        </Typography>
                        <Stack paddingBottom={2}>
                                <Typography>{store.displayAddress} {store.city}</Typography>
                                <Typography component="span" sx={pickStoreLinkSx} onClick={() => setPopupStoreAndFeature({ store, feature: feature, stock })}>
                                    {ClickAndCollectNLS.StoreHoursLink.t()}<KeyboardArrowRightIcon sx={{ fontSize: 23, verticalAlign: 'middle', cursor: 'pointer' }} />
                                </Typography>
                            <StoreStockDetailsDisplay {...{store, stock, storeFeature:feature}} />
                        </Stack>
                        <Button 
                            variant="clickThrough" 
                            sx={pickStoreBtnSx} 
                            role="button"
                            onClick={()=>{
                                setSelectedStore({store, feature, stock});
                                setSelectedIndex(i);  
                            }}
                            disabled={selectedIndex === i} 
                        >
                            {ClickAndCollectNLS.PickUPAtThisStore.t()}
                        </Button>
                    </Box>
                   
                </Stack>
            )}

            {popupStoreAndFeature &&
                <StoreDetailsPopup {...{popupStoreAndFeature, setPopupStoreAndFeature}} />
            }
            
        </>

    );
}